import BoldText from '@/components/BoldText';
import CustomCard from '@/components/customCard';
import { BubbleChatIcon, DocumentationIcon, LetterIcon } from '@/components/Icons';
import { USER_GUIDE_LINK } from '@/constants/path';
import { openCrisp } from '@/helpers';
import { useCanny } from '@/hooks/useCanny';
import { Card, Icon, InlineGrid, Link } from '@shopify/polaris';
import { ExternalIcon, HomeIcon } from '@shopify/polaris-icons';
import { memo, useMemo } from 'react';
import { HelpCenterStyled } from './styled';

const HelpCenter = () => {
  useCanny();
  const listActions = useMemo(() => {
    return [
      { id: 0, icon: <BubbleChatIcon />, title: '24/7 Live chat', desc: 'Reply immediately', onClick: openCrisp },
      {
        id: 1,
        icon: <LetterIcon />,
        title: 'Contact email',
        desc: 'Typically reply in 24h',
      },
      {
        id: 2,
        icon: <DocumentationIcon />,
        title: (
          <span className="d-flex">
            User guide docs <Icon source={ExternalIcon} />
          </span>
        ),
        desc: 'Find solutions on your own',
        onClick: () => {
          window.open(USER_GUIDE_LINK.GUIDE_LINK, '_blank');
        },
      },
      // {
      //   id: 3,
      //   icon: <LightBulbIcon />,
      //   title: 'Feedback and request',
      //   desc: 'Share issues and request features',
      //   onClick: () => {
      //     navigate(PATH.FEEDBACK);
      //   },
      // },
      // {
      //   id: 4,
      //   icon: <ChangeLogIcon />,
      //   title: 'Changelog',
      //   desc: 'Latest app updates notice',
      //   onClick: () => {
      //     window.open('https://estimated.canny.io/changelog', '_blank');
      //   },
      // },
    ];
  }, []);

  const col = listActions.length;

  return (
    <HelpCenterStyled>
      <CustomCard
        title={
          <div className="d-flex">
            <div className="mr-4">
              <Icon source={HomeIcon} />
            </div>
            <BoldText>Help and resources</BoldText>
          </div>
        }
      >
        <div className="mt-8 content-wrap">
          <InlineGrid columns={{ xl: col, lg: col, md: col, sm: 1, xs: 1 }} gap={'400'}>
            {listActions.map((action) => {
              if (action.id === 1) {
                return (
                  <Link key={action.id} url="mailto:contact@omegatheme.com" removeUnderline target="_blank">
                    <Card>
                      <div className="flex-center flex-column" style={{ gap: '4px' }}>
                        {action.icon}
                        <BoldText>{action.title}</BoldText>
                        <p className="text-center">{action.desc}</p>
                      </div>
                    </Card>
                  </Link>
                );
              }
              if (action.id === 4) {
                return (
                  <button id="canny-changelog-button" key={4} data-canny-changelog>
                    <Card>
                      <div className="flex-center flex-column" style={{ gap: '4px' }}>
                        {action.icon}
                        <BoldText>{action.title}</BoldText>
                        <p className="text-center">{action.desc}</p>
                      </div>
                    </Card>
                  </button>
                );
              }
              return (
                <div className="card-wrap" key={action.id} onClick={action.onClick}>
                  <Card>
                    <div className="flex-center flex-column" style={{ gap: '4px' }}>
                      {action.icon}
                      <BoldText>{action.title}</BoldText>
                      <p className="text-center">{action.desc}</p>
                    </div>
                  </Card>
                </div>
              );
            })}
          </InlineGrid>
        </div>
      </CustomCard>
    </HelpCenterStyled>
  );
};

export default memo(HelpCenter);
